import styled from 'styled-components';

export const CheckBoxCellStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
